import { render } from "./productCatagory.vue?vue&type=template&id=0623c468"
import script from "./productCatagory.vue?vue&type=script&lang=js"
export * from "./productCatagory.vue?vue&type=script&lang=js"

import "./productCatagory.vue?vue&type=style&index=0&id=0623c468&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__